import apiClient from '../../helpers/apiClient';
import { authHeader } from '../../helpers/authHelpers';
import { getAPIDomain } from '../../helpers/configHelpers';
import { logger } from '../../helpers/logger';

export const FORM_DATA_INIT = 'FORM_DATA_INIT';
export const FORM_UPDATE_DATA = 'FORM_UPDATE_DATA';

export const SITE_ACTIVE_INDEX = 'SITE_ACTIVE_INDEX';
export const SECTION_ACTIVE_INDEX = 'SECTION_ACTIVE_INDEX';
export const SUBSECTION_ACTIVE_INDEX = 'SUBSECTION_ACTIVE_INDEX';

export const RESET_ACTIVE_INDEX = 'RESET_ACTIVE_INDEX';

export const FORM_SAVE_START = 'FORM_SAVE_START';
export const FORM_SAVE_ERROR = 'FORM_SAVE_ERROR';
export const FORM_SAVE_END = 'FORM_SAVE_END';

export const FORM_SUBMIT_START = 'FORM_SUBMIT_START';
export const FORM_SUBMIT_ERROR = 'FORM_SUBMIT_ERROR';
export const FORM_SUBMIT_END = 'FORM_SUBMIT_END';

const request = {
  save: {
    start: FORM_SAVE_START,
    error: FORM_SAVE_ERROR,
    action: FORM_SAVE_END,
  },
  submit: {
    start: FORM_SUBMIT_START,
    error: FORM_SUBMIT_ERROR,
    action: FORM_SUBMIT_END,
  },
};

const formRoute = ({ id, type, submitUrl, saveUrl }) => {
  const APIdomain = getAPIDomain();

  // replace can probs be removed, once checked on site
  const API = APIdomain && APIdomain.replace('/page', '');

  const routes = {
    save: `${API}/${saveUrl.replace('{id}', id)}`,
    submit: `${API}/${submitUrl.replace('{id}', id)}`,
  };

  return routes[type];
};

export const makeRequest =
  ({ type = 'save', recaptchaToken }) =>
  async (dispatch, getState) => {
    const { sites, id, active, submitUrl, saveUrl } = getState().annualRenewals;
    const endpoint = formRoute({ id, type, submitUrl, saveUrl });

    // start state / loading
    dispatch({
      type: request[type].start,
      payload: true,
      recaptchaToken,
    });

    // post form data
    // TODO: check active data works on save / refresh of page
    const payload = {
      form: { sites, ...(active ? { active } : {}) },
      recaptchaToken: recaptchaToken || null,
    };

    apiClient
      .post(endpoint, payload, {
        headers: authHeader('U0pQOlBhcnRuZXI=', 'application/json'),
      })
      .then((res) => {
        // check response is good / if not error
        const response = res || null;
        if (response) {
          if (response?.status === 200 && response?.data) {
            dispatch({
              type: request[type].action,
              // probs just toggle loading state off / show message? finish state
              payload: response.data,
            });
          } else {
            // here for testing
            throw 'response not successful';
          }
        }
      })
      .catch((error) => {
        logger.error(error);
        dispatch({ type: request[type].error });
      });
  };

const indexTypes = {
  site: {
    action: SITE_ACTIVE_INDEX,
  },
  section: { action: SECTION_ACTIVE_INDEX },
  subsection: { action: SUBSECTION_ACTIVE_INDEX },
};

// can set active index - type [site, section, subsection]
export const setActiveIndex =
  ({ index, type, indexes, reset }) =>
  async (dispatch, getState) => {
    const { sites } = getState().annualRenewals;

    const arrayLength = {
      site: sites.length || null,
      section: sites[indexes?.siteIndex]?.sections.length || null,
      subsection: sites[indexes?.siteIndex]?.sections[indexes?.sectionIndex].length || null,
    };

    let setIndex = index;

    if (index < 1) {
      setIndex = 0;
    } else if (index > arrayLength[type] - 1) {
      setIndex = arrayLength[type] - 1;
    }

    if (type) {
      dispatch({
        type: indexTypes[type].action,
        payload: setIndex,
      });
    }

    if (reset) {
      dispatch({
        type: RESET_ACTIVE_INDEX,
        payload: {
          section: 0,
          subsection: 0,
        },
      });
    }
  };

// resets active index mainly for site toggle - resets [section, subsection]
export const resetActiveIndex = () => async (dispatch) => {
  dispatch({
    type: RESET_ACTIVE_INDEX,
    payload: {
      section: 0,
      subsection: 0,
    },
  });
};

export const updateFormData =
  ({ data }) =>
  async (dispatch) => {
    if (data) {
      dispatch({
        type: FORM_UPDATE_DATA,
        payload: data,
      });
    }
  };

export const setInitalFormData = (data) => async (dispatch) => {
  if (data) {
    dispatch({
      type: FORM_DATA_INIT,
      payload: data,
    });
  }
};
